import React, { useEffect, useState } from 'react';
import { Box, Button, Typography, withStyles, Tooltip, Dialog, DialogTitle, DialogContent, DialogActions, Paper, Card, CardHeader, CardContent, IconButton } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import Slider from '../../../Social/NetflixSlider';
import styles from '../../../styles/browseStory.js';
import BookShareTable from '../Shared/BookShareTable';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { getDatabank } from '../../../redux/actions';
import Select from 'react-select';
import BookShareCredentialsLogin from './BookShareCredentialsLogin';
import Download from '../Shared/Download'
import { addStoryToStudent, importStoryList, getBookShareUsers, getBooksForStudent } from '../../../redux/actions/platform/books.js'
import BookShareUserTable from '../../../Social/NetflixSlider/BookShareUserTable';
import { RESET_IMPORT_MODAL } from '../../../redux/constants';
import { formatBookLevelDisplay } from '../../../helpers';

let GradeLevelList = [
    { value: 0, label: 'K' },
    { value: 1, label: '1' },
    { value: 2, label: '2' },
    { value: 3, label: '3' },
    { value: 4, label: '4' },
    { value: 5, label: '5' },
    { value: 6, label: '6' },
    { value: 7, label: '7' },
    { value: 8, label: '8' },
    { value: 9, label: '9' },
    { value: 10, label: '+10'}
];

const rows = [
    // Grade Level table headers
    { id: 'titleImageSrc', label: <FormattedMessage id="General.image" />},
    { id: 'gradeLevel', label: <FormattedMessage id='General.gradeLevel' /> },
    { id: 'name', label: <FormattedMessage id='General.title' /> },
    { id: 'author', label: <FormattedMessage id='General.author' /> },
    { id: 'isbn', label: <FormattedMessage id='General.isbn' /> },
    { id: 'source', label: <FormattedMessage id='General.source' /> }
];

function DisplayStoryList({ id, databank, student, storyList, type, classes, dispatch, storyId, imported, user, closeWizard, booksImport, bookShareUsers }) {
    const [noResultFound, setNoResultFound] = useState(false);
    const [dbank, setDbank] = useState([]);
    const [lexile, setLexile] = useState({
        value: 0,
        label: 'K'
    });
    const [loginRequired, setLoginRequired] = useState(null);
    // const [showLoading, setShowLoading] = useState(false);
    const [loadingListId, setLoadingListId] = useState(null);
    // const [showCheckmark, setShowCheckmark] = useState(false)
    const [completedListIds, setCompletedListIds] = useState([]);
    const [showLevelImportWarning, setShowLevelImportWarning] = useState(false);
    const [pendingImportList, setPendingImportList] = useState(null);
    
    // Error handling state for "Cannot find Student Match"
    const [showImportMessage, setShowImportMessage] = useState(false);
    const [importErrorMessage, setImportErrorMessage] = useState("");
    const [messageLink, setMessageLink] = useState("");
    const [showStudent, setShowStudent] = useState(false);

    useEffect(() => {
        if (databank.length >  0) {
            let newDB = filterDB();
                if (user.type == "Individual" && user.hasBookShareCredentials == false) {
                    newDB = newDB.filter(data => data.source == "ObjectiveEd");
                }
            setDbank(newDB);
        }
    }, [databank, user])
    

    useEffect(() => {
        if (storyList.length) {
            setNoResultFound(true);
        }
    }, [storyList])

    useEffect(() => {
        if (type === 'LexileStory') {
            console.log('databank', databank);
        }
    }, [type])
    
    useEffect(() => {
        let newDB = filterDB();
        console.log(newDB);
        if (user.type == "Individual" && user.hasBookShareCredentials == false) {
            newDB = newDB.filter(data => data.source == "ObjectiveEd");
        }
        setDbank(newDB);
    }, [lexile])

    // Error handling useEffect for story list import errors
    useEffect(() => {
        if (booksImport && booksImport.message) {
            const messageString = typeof booksImport.message === 'string' 
                ? booksImport.message 
                : booksImport.message.message || JSON.stringify(booksImport.message);
            
            console.log('DisplayStoryList: Import error detected:', messageString);
            
            if (messageString === "Cannot find Student Match") {
                setShowImportMessage(true);
                setImportErrorMessage(
                    "We can't find this student in your Bookshare account, please check the list for the correct student and press the (+) icon."
                );
                setLoginRequired(false);
                setMessageLink("https://www.bookshare.org/orgAccountMembers");
                dispatch({ type: RESET_IMPORT_MODAL });
                
                // Fetch BookShare users if not already available
                if (!bookShareUsers || bookShareUsers.length === 0) {
                    dispatch(getBookShareUsers());
                }
                
                // Reset loading states
                setLoadingListId(null);
                setCompletedListIds([]);
            }
        }
    }, [booksImport, bookShareUsers, dispatch])

    const filterDB = () => {
        let selectedValue = lexile.value
        let newDB = databank && databank.filter(db => {
            if(selectedValue === 10 ){
                return db.gradeLevel >= 10
            }
            else{
                return db.gradeLevel == selectedValue
            }
        })
        return newDB;
    }

    const importMany = async (list) => {
        setLoadingListId(list.id);
        if (list && student && list.id) {
            const studentId = student.id;
            const storyListId = list.id;
            
            try {
                await dispatch(importStoryList(studentId, storyListId));
                
                // Visual indication of successful import
                setTimeout(() => setCompletedListIds(prev => [...prev, list.id]), 1000);
                setTimeout(() => setLoadingListId(null), 1100);
                
                // Refresh books data on the Books page after a delay to ensure backend processing completes
                setTimeout(() => {
                    dispatch(getBooksForStudent(studentId));
                }, 3000);
            } catch (error) {
                console.error("Failed to import story list:", error);
                setTimeout(() => setLoadingListId(null), 1100);
            }
        } else {
            console.error("Missing required data:", { list: !!list, student: !!student, listId: list && list.id });
        }
    };

    const handleImportClick = (list) => {
        // Check if this is a Level list or Recommendations list
        if ((list.type && list.type.includes('Level')) || (list.type && list.type.includes('Recommendations'))) {
            // Show warning modal for Level lists and Recommendations lists
            setPendingImportList(list);
            setShowLevelImportWarning(true);
        } else {
            // Direct import for other list types
            importMany(list);
        }
    };

    const confirmLevelImport = () => {
        if (pendingImportList) {
            importMany(pendingImportList);
        }
        setShowLevelImportWarning(false);
        setPendingImportList(null);
    };

    const cancelLevelImport = () => {
        setShowLevelImportWarning(false);
        setPendingImportList(null);
    };

    // This is the slider of book covers that first shows when you click Add Books, and the Dialog / Modal opens on Recommendations.
    const RecommendList = (list, force) => {
        let styleRecommended = {};
        if ((user.type === "Individual" || user.type === "Teacher") && !user.hasBookShareCredentials && list.locked === 'Y') {
            styleRecommended = { pointerEvents: 'none', opacity: '0.2' }
        }
        // Display-only: format any "Level N" tokens to "Level N00"
        const displayName = list && list.name
            ? list.name.replace(/Level\s*\d+/ig, (m) => formatBookLevelDisplay(m))
            : list.name;
        return (
            <div style={{ backgroundColor: 'rgba(255,255,255,0.62)' }} key={list.id}>
                <Box sx={{ p: 2 }}>
                    <Typography variant='h4' component='h4' style={{ color: "#00729b" }}>
                        <b>
                            {displayName}
                            {user.hasBookShareCredentials && (list.locked === 'N' || list.locked === null) && ' by ObjectiveEd'}
                        </b>

                        {user.hasBookShareCredentials || list.locked !== 'Y' ?
                            <Tooltip
                                title={<FormattedMessage id='Databanks.addAllSlider'/>}
                                enterDelay={300}
                                placement="right"
                            >
                            <span>
                                <Download
                                        checked={completedListIds.includes(list.id)} // checked for importMany is faux feedback
                                        loading={loadingListId === list.id}
                                        onDownload={(e) => handleImportClick(list)}
                                        // no bookId or failedImportBookIds here bc importMany
                                />   
                            </span>
                            </Tooltip>
                            :
                            <></>
                        }
                    </Typography>
                    <div style={{ position: 'relative' }}>
                        {(user.type === "Individual" || user.type === "Teacher") && !(user.hasBookShareCredentials) && (list.locked === 'Y') &&
                            <Button className={classes.bookshareLoginButton} variant='contained' onClick={() => handleBookshareLogin()}>
                                Login to Bookshare to Access More Content.</Button>}
                        <Box className={classes.recommendListBox} style={styleRecommended}>
                            {
                                <Slider>
                                    {list.items && list.items.length > 0 && list.items.map((storyItem, itemIndex) => {
                                        // Create a unique key combining list ID, story ID, and index as fallback
                                        const uniqueKey = storyItem.id ? `${list.id}-story-${storyItem.id}` : `${list.id}-item-${itemIndex}`;
                                        return (
                                            <Slider.Item movie={storyItem} storyHeader={displayName} id={id} key={uniqueKey}>item1</Slider.Item>
                                        );
                                    })}
                                </Slider>
                            }
                        </Box>
                    </div>
                </Box>
            </div>
        )
    }

    const ReadingList = () => {
        return (
            <div style={{ minHeight: '395px', textAlign: 'center' }}>Reading List</div>
        )
    }
    
    const handleChangeLexileLevel = (e) => {
        console.log(e);
        setLexile(e.target.value);
    }
    const handleBookshareLogin = () => {
        setLoginRequired(true);
    }
    const closeLoginModal = () => {
        setLoginRequired(false);
    }

    const closeImportMessageModal = () => {
        setShowImportMessage(false);
    };

    const addStudent = () => {
        setShowStudent(true);
    };

    const handleStudentWizardClose = () => {
        setShowStudent(false);
    };

    return (
        <div
        // style={{ backgroundColor: '#d3e6ff' }}
        >
            {type === 'Recomendations' &&
                storyList.constructor === Array && storyList.length > 0 &&
                storyList
                    .filter(list => list.type === 'Recommendations')
                    .map((list, index) => RecommendList(list))
                    .filter(Boolean) // Remove null values
            }
            {
                type === 'LexileStory' &&
                storyList.constructor === Array && storyList.length > 0 &&
                storyList
                    .filter(list => list.type && list.type.includes('Level'))
                    .map((list, index) => RecommendList(list))
                    .filter(Boolean) // Remove null values
            }
            {
                type === 'StudentStory' &&
                ReadingList()
            }
            {loginRequired && <BookShareCredentialsLogin
                openLoading={loginRequired}
                exitFunc={closeLoginModal} />}
            
            {/* Error Message Modal for "Cannot find Student Match" */}
            <Dialog
                open={showImportMessage}
                maxWidth="lg"
                onClose={closeImportMessageModal}
            >
                <Paper className="list">
                    <Card aria-label="Message">
                        <CardHeader
                            style={{ backgroundColor: "#00729b", marginBottom: "20px" }}
                            action={
                                <IconButton onClick={closeImportMessageModal}>
                                    <Close />
                                </IconButton>
                            }
                            title={
                                <Typography variant="h5" className="header">
                                    {bookShareUsers ? "Link Student" : "Something went wrong"}
                                </Typography>
                            }
                        />
                        <CardContent
                            className="synopsis_description"
                            style={{ textAlign: "center", fontFamily: "Calibri, sans-serif" }}
                        >
                            <div style={{ textAlign: "center" }}>
                                {importErrorMessage}
                                <br />
                            </div>

                            {messageLink &&
                            messageLink.length > 0 &&
                            bookShareUsers ? (
                                <>
                                    <br />
                                    <BookShareUserTable
                                        student={student}
                                        storyId={id}
                                        closeImportMessageModal={closeImportMessageModal}
                                        messageLink={messageLink}
                                        showStudent={showStudent}
                                        addStudent={addStudent}
                                        handleStudentWizardClose={handleStudentWizardClose}
                                    />
                                </>
                            ) : null}
                        </CardContent>
                    </Card>
                </Paper>
            </Dialog>
            
            {/* Import List Warning Modal */}
            {showLevelImportWarning && (
                <Dialog
                    open={showLevelImportWarning}
                    onClose={cancelLevelImport}
                    maxWidth="sm"
                    fullWidth
                >
                    <DialogTitle>Import List Warning</DialogTitle>
                    <DialogContent>
                        <Typography>
                            Importing a list removes all un-started books on this student's account and adds all the books from this list.
                        </Typography>
                        <Typography style={{ marginTop: '16px', fontWeight: 'bold' }}>
                            Do you still want to import this list?
                        </Typography>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={cancelLevelImport} color="secondary">
                            Cancel
                        </Button>
                        <Button onClick={confirmLevelImport} color="primary" variant="contained">
                            Yes, Import
                        </Button>
                    </DialogActions>
                </Dialog>
            )}
        </div>

    )
}

const mapState = ({ platform: { databank, student, booksImport, bookShareUsers }, shared: { user } }) => {
    return {
        databank,
        student,
        user,
        booksImport,
        bookShareUsers
    }
};

export default connect(mapState)(withStyles(styles)(DisplayStoryList));